const updateWaveBg = () => {
  const waveMax = document.querySelector('.waveMax');
  const waveBg = document.querySelector('.waveBg');

  if (waveBg && waveMax) {
    waveBg.style.height = `calc(${waveMax.offsetTop}px + 15vw)`;
  }
};

const delayUpdateWaveBg = () => {
  if (document.body.classList.contains('page-template-accueil')) {
    setTimeout(updateWaveBg, 1250);
  } else {
    updateWaveBg();
  }
};

window.addEventListener('load', delayUpdateWaveBg);
window.addEventListener('resize', updateWaveBg);
